export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.newpageCategories = payload;

  return newState;
};
